export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const areaCalculationType = [
  { id: "line", name: "Line" },
  { id: "route", name: "Route" },
];

export const pricingPolicyList = [
  { id: "contactDays", name: "Contact Days" },
  { id: "fullCalendarDays", name: "Full Calendar Days" },
];
